export default __webpack_public_path__ + "static/media/Four-in-one-sensor-Inactive_v1.93234c20.svg";